<template>
    <div class="uc">
        <div class="uc-head">
            <span class="ak-label uc-title">Usage (tender records served per day)</span>
            <div class="uc-range" role="group" aria-label="Range">
                <button type="button" :class="{ on: days === 7 }" @click="$emit('range', 7)">7 days</button>
                <button type="button" :class="{ on: days === 30 }" @click="$emit('range', 30)">30 days</button>
            </div>
        </div>

        <div v-if="loading" class="uc-note">Loading usage...</div>
        <div v-else-if="!rows.length" class="uc-note">No usage recorded in this period.</div>
        <template v-else>
            <div class="uc-totals">
                <div><strong>{{ total('tenders_served').toLocaleString('en-IN') }}</strong><span>tenders served</span></div>
                <div><strong>{{ total('requests').toLocaleString('en-IN') }}</strong><span>requests</span></div>
                <div><strong>{{ total('errors').toLocaleString('en-IN') }}</strong><span>errors</span></div>
            </div>
            <div class="uc-bars" role="img" :aria-label="`Tenders served per day over the last ${days} days`">
                <div v-for="r in rows" :key="r.day" class="uc-col"
                    :title="`${r.day}: ${r.tenders_served} tenders, ${r.requests} requests, ${r.errors} errors`">
                    <div class="uc-bar" :style="{ height: barHeight(r.tenders_served) + '%' }"
                        :class="{ err: r.errors > 0 }"></div>
                </div>
            </div>
            <div class="uc-axis">
                <span>{{ rows[0].day }}</span>
                <span>{{ rows[rows.length - 1].day }}</span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ApiKeyUsageChart',
    props: {
        rows: { type: Array, default: () => [] },
        days: { type: Number, default: 7 },
        loading: { type: Boolean, default: false },
    },
    emits: ['range'],
    computed: {
        max() {
            return Math.max(1, ...this.rows.map(r => r.tenders_served || 0));
        },
    },
    methods: {
        total(field) {
            return this.rows.reduce((sum, r) => sum + (r[field] || 0), 0);
        },
        barHeight(v) {
            if (!v) return 2;
            return Math.max(4, Math.round((v / this.max) * 100));
        },
    },
};
</script>

<style scoped>
.uc { display: flex; flex-direction: column; gap: 0.75rem; }
.uc-head { display: flex; justify-content: space-between; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
.uc-title { margin: 0; }
.uc-range { display: inline-flex; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; background: #f8fafc; }
.uc-range button {
    border: none; background: transparent; padding: 0.3rem 0.7rem; font-size: 0.74rem; font-weight: 700;
    color: var(--text-secondary); cursor: pointer; font-family: var(--font-sans);
}
.uc-range button + button { border-left: 1px solid #e2e8f0; }
.uc-range button.on { background: #0071C5; color: #fff; }
.uc-note { padding: 1.5rem; text-align: center; color: #94a3b8; font-size: 0.85rem; background: #f8fafc; border-radius: 12px; }
.uc-totals { display: flex; gap: 1.5rem; flex-wrap: wrap; }
.uc-totals div { display: flex; flex-direction: column; }
.uc-totals strong { font-size: 1.2rem; color: var(--text-primary); }
.uc-totals span { font-size: 0.72rem; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
.uc-bars { display: flex; align-items: flex-end; gap: 3px; height: 110px; padding: 0.5rem; background: #f8fafc; border-radius: 12px; }
.uc-col { flex: 1; height: 100%; display: flex; align-items: flex-end; min-width: 0; }
.uc-bar { width: 100%; background: linear-gradient(180deg, #0084FF, #0071C5); border-radius: 3px 3px 0 0; min-height: 2px; }
.uc-bar.err { background: linear-gradient(180deg, #f59e0b, #d97706); }
.uc-axis { display: flex; justify-content: space-between; font-size: 0.7rem; color: #94a3b8; font-weight: 600; }
</style>
